import { z } from "zod";

const zTournamentTag = z.object({
    tournamentId: z.string().uuid().nullable(),
});
const zPlayerTag = z.object({
    playerId: z.string().uuid().nullable(),
    kind: z.enum(["FEATURE", "MENTION"]),
});

const zBaseArticleInput = z.object({
    title: z.string(),
    source: z.preprocess(arg => {
        if (typeof arg === "string" && arg.trim() === "") {
            return null;
        }

        return arg;
    }, z.string().trim().nullable().optional()),
    imageId: z.string().uuid().nullable().optional(),
    videoId: z.string().uuid().nullable().optional(),
    tournamentTags: zTournamentTag.array(),
    playerTags: zPlayerTag.array(),
});

export const zArticleInput = z.discriminatedUnion("kind", [
    z
        .object({
            kind: z.literal("rich_text"),
            content: z.array(z.unknown()),
        })
        .merge(zBaseArticleInput),
    z
        .object({
            kind: z.literal("external_url"),
            url: z.string().url(),
        })
        .merge(zBaseArticleInput),
    z
        .object({
            kind: z.literal("story"),
            items: z
                .array(
                    z.object({
                        id: z.string().uuid().optional(),
                        rank: z.number(),
                        content: z.union([
                            z.object({
                                image: z.object({
                                    id: z.string().uuid(),
                                    duration: z.number().optional(),
                                }),
                            }),
                            z.object({
                                video: z.object({
                                    id: z.string().uuid(),
                                }),
                            }),
                        ]),
                    })
                )
                .min(1),
        })
        .merge(zBaseArticleInput),
]);
export type ArticleInput = z.infer<typeof zArticleInput>;
